import { create } from 'zustand';

// Global Help Center state. Any component (top-nav "?", the AI Companion "?",
// a Settings item, or a contextual page button) can open the slide-over and
// optionally deep-link to a specific article by id.
type HelpState = {
  open: boolean;
  topic: string | null; // article id to land on, or null for the home list
  openHelp: (topic?: string) => void;
  close: () => void;
};

export const useHelpStore = create<HelpState>((set) => ({
  open: false,
  topic: null,
  openHelp: (topic) => set({ open: true, topic: topic ?? null }),
  close: () => set({ open: false }),
}));

// Convenience for non-react callers.
export const openHelp = (topic?: string) => useHelpStore.getState().openHelp(topic);
